module.exports = {
  GOOGLE_SIGNIN_FROM: 'googleSigninFrom',
  GOOGLE_SIGNIN_SOURCE: 'googleSigninSource',
  GOOGLE_SIGNIN_REDIRECT: 'googleSigninRedirect',
}
